export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_START_PAGE_NUMBER = 1;
export const ITEMS_PER_PAGE = 10;
export const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50];
export const COLUMN_ALIGNMENTS = ['left', 'center', 'right'] as const;
export const WARNING_TYPE = {
  DISCARD_CHANGES: 'discard_changes',
  SAVE_CHANGES: 'save_changes',
  ERROR_IN_CHANGES: 'error_in_changes',
} as const;